<template>
  <div class="dtablerow sellinone">


    <!-- Left Panel -->
    <!--<aside id="left-panel" class="left-panel">-->
    <!--<LeftMenu/>-->
    <!--</aside>&lt;!&ndash; /#left-panel &ndash;&gt;-->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panelx" class="right-panel fContainer">

      <SellHeader></SellHeader>

      <div class="content mt-3 fColumn pb-15">
        <div class="animated fadeIn fColumn">


          <form action="/" method="post" id="form" class="userForm ajaxForm fColumn">

            <div class="card fColumn fCard">
              <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>


              <div class="card-headerX fHead card-body">
                <div class="d-block d-md-table w100">
                  <!--<table class="w100">-->
                  <!--<tr>-->
                  <!--<td class="valignbottom  pr-1">-->
                  <div class="d-block  pb-1 discountChooser d-md-table-cell text-nowrap pr-1">
                    <template v-if="this.discountchooses.length>0">
                      <table>
                        <tr>
                          <template v-for="(element, i) in this.discountchooses">
                            <td class="discountChooserElement">
                              <button type="button" class="btn btn-danger " v-on:click="discountChooserElementClickHandler(element.discount_percentage)">
                                {{element.discount_percentage + " %"}}
                              </button>&nbsp;
                            </td>
                          </template>
                          <button type="button" class="btn btn-danger " v-on:click="discountChooserElementClickHandler(0)">
                            &nbsp;X
                          </button>&nbsp;
                        </tr>
                      </table>
                    </template>
                  </div>

                  <!--</td>-->
                  <!--<td class="valigntop pr-1">-->
                  <BuyerSearcher class="d-block  pb-1 d-md-table-cell pl-1 pr-1"></BuyerSearcher>

                  <!--</td>-->
                  <!--<td class="valigntop pr-1  pl-1">-->
                  <div class="d-block  pb-1 d-md-table-cell text-nowrap pl-1 pr-1">
                    <div class="input-group" style="top:2px;">
                                                    <span v-if="businesspartner.id" class="btn btn-success Xinput-group-addon float-right"
                                                          v-on:click="$eventBus.$emit('globalChooseProductSearcher', {type:'BusinessPartnerSearcher'})">
                                                        <i class="fa fa-briefcase"></i>
                                                    </span>
                      <span v-if="!businesspartner.id" class="btn btn-info Xinput-group-addon float-right"
                            v-on:click="$eventBus.$emit('globalChooseProductSearcher', {type:'BusinessPartnerSearcher'})">
                                                        <i class="fa fa-briefcase"></i>
                                                    </span>
                      <InputText style="flex:1 1 0px" hasToKeyboard="false" id="x"
                                 :value="(businesspartner.taxnumber || businesspartner.businesspartnername)?businesspartner.businesspartnername + ', ' + businesspartner.taxnumber:''"
                                 title="" placeholder="" className="form-control w100 d-block" readonly/>
                      <a style="flex: 0.01 1;" class="btn_del_input input-group-addon pointer" data-id="0" v-on:click="clickToClearBusinessPartner()">
                        <div class=" "><i class="fa fa-times"></i></div>
                      </a>
                      <template v-if="businesspartner.discount">
                        <div style="flex: 0.02 0 0;" class="input-group-addonX discount_type_container discount_type btn btn-danger ">{{businesspartner.discount}}<span
                          v-if="businesspartner.discount">%</span></div>
                      </template>
                      <template v-if="!businesspartner.discount">
                        <div style="flex: 0.02 0 0;" class="input-group-addon discount_type_container discount_type">{{businesspartner.discount}}<span
                          v-if="businesspartner.discount">%</span></div>
                      </template>
                    </div>
                  </div>
                  <!--</td>-->
                  <!--<td class="valignbottom text-right  pl-1">-->
                  <div class="d-block  pt-1 d-md-table-cell text-nowrap text-right pl-1 pr-1">
                    <button type="button" class="btn btn-success  btn-reprint " v-on:click="$eventBus.$emit('globalChooseProductSearcher', {type:'ProductSearcherByNameBarcode'})">
                      <i class="fa fa-search"></i>{{$t('productTabs.sellBarcodeAndName')}}
                    </button>
                  </div>

                  <!--</td>-->
                  <!--</tr>-->
                  <!--</table>-->
                </div>

              </div>
              <div class="card-body card-block pt-0 pb-0 fColumn">
                <div class="fColumn">

                  <div class="row ">
                    <div class="col-sm-4 scrollHeightEnable600x receiptDisplayContainer fContent pt-15 pb-15 pt-05em-i ">

                      <!--<BasketDisplayer :discount="buyer.discount"></BasketDisplayer>-->

                      <table class="w100">

                        <template v-for="(e, index) in purcaseItemsExtend">

                          <template v-if="Number(e.pack) === 1" class="table">
                            <tr>
                              <td class="">
                                <!--<span :for="'text-input' + e.itemKey " class="form-control-label">{{Helper.getValueByIdAndKeyFromObjectArray("name", elements, e.itemKey) }}</span>-->
                                <span :for="'text-input' + e.itemKey " class="form-control-label">{{e.name}}</span>
                              </td>
                              <td class="text-right  text-nowrap pl-1 price" style="">
                                <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemCountnum}}</span>
                                x
                              </td>
                              <td class="text-right  text-nowrap pl-1 price" style="">
                                <small class="">{{prefix}}</small>
                                <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemPrice}}</span>
                                <small class="">{{suffix}}</small>
                              </td>
                              <td class="text-right  text-nowrap pr-1 pl-1 price" style="">
                                <small class="">{{prefix}}</small>
                                <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemSumPrice}}</span>
                                <small class="">{{suffix}}</small>
                              </td>
                              <td class="icons">
                                <!--v-if="justDisplay=='false'"-->
                                <div class="input-group">
                                  <a class="btn_delrow input-group-addon " v-on:click="delrow(index)">
                                    <div class=" "><i class="fa fa-times"></i></div>
                                  </a>
                                </div>
                              </td>
                            </tr>


                          </template>
                          <template v-if="Number(e.pack) >= 2 && Number(e.pack) <= 7" class="table">

                            <tr>
                              <td class="">
                                <span :for="'text-input' + e.itemKey " class="form-control-label">{{e.name}}</span>
                              </td>
                              <td class="text-right  text-nowrap price" style="">
                                <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemValue}}</span>
                                <!--<span id="text-display' + e.itemKey + '" class="" data-id="' + e.itemKey + '">' + e.itemValue + '</span>-->

                                <small class="" v-if="e.pack==='2'"> {{$t('global.pc')}}</small>
                                <small class="" v-if="e.pack==='3'"> {{$t('global.kg')}}</small>
                                <small class="" v-if="e.pack==='4'"> {{$t('global.l')}}</small>
                                <small class="" v-if="e.pack==='5'"> {{$t('global.m')}}</small>
                                <small class="" v-if="e.pack==='6'"> {{$t('global.pack')}}</small>
                                <small class="" v-if="e.pack==='7'"> {{$t('global.occasion')}}</small>
                              <td class="text-right  text-nowrap pl-1 price" style="">
                                <small class="">{{prefix}}</small>
                                <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemPrice}}</span>
                                <small class="">{{suffix}}</small>
                              </td>
                              <td class="text-right  text-nowrap pr-1 pl-1 price" style="">
                                <small class="">{{prefix}}</small>
                                <span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{e.itemSumPrice}}</span>
                                <small class="">{{suffix}}</small>
                              </td>

                              <!--</td>-->
                              <!--<td class="text-right price" style="">-->
                              <!--<small class="">{{prefix}}</small>-->
                              <!--<span :id="'text-display' + e.itemKey" class="" :data-id="e.itemKey">{{ (Number(e.default_price) * e.itemValue) }}</span>-->
                              <!--<small class="">{{suffix}}</small>-->
                              <!--</td>-->
                              <td class="icons">
                                <!--v-if="justDisplay=='false'"-->
                                <div class="input-group">
                                  <a class="btn_delrow input-group-addon " v-on:click="delrow(index)" data-id="' + i + '">
                                    <div class=" "><i class="fa fa-times"></i></div>
                                  </a>
                                </div>
                              </td>
                            </tr>

                          </template>


                        </template>
                      </table>


                      <div v-if="Number(discount_price)>0&&discount_price>0">
                        <table class="table">
                          <tr>
                            <td class=" extensionLineX">
                              <span class="form-control-label">{{$t('global.discount')}}</span>
                            </td>
                            <td class=" text-right text-nowrap extensionLineX">
                              <small class="">{{prefix}}</small>
                              <span id="Xdiscount_price" class="discount_price">{{discount_price}}</span>
                              <small class="">{{suffix}}</small>
                            </td>
                          </tr>
                        </table>
                      </div>

                      <div v-if="Number(sum)!=0">
                        <table class="table">
                          <tr>
                            <td class="extensionLineX">
                              <span class="form-control-label">{{$t('global.sumPrice')}}</span>
                            </td>
                            <td class="text-right text-nowrap extensionLineX">
                              <small class="">{{prefix}}</small>
                              <span id="" class="sum">{{sum}}</span>
                              <small class="">{{suffix}}</small>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <!--<input type="text" placeholder="Text input" @focus="show" data-layout="normal" />-->
                      <!--<vue-touch-keyboard :options="options" v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input" />-->
                      <!--<InputText hasToKeyboard value="value" title="title" placeholder="placeholder" dataLayout="t"/>-->
                      <!--<InputText hasToKeyboard value="value" title="title" placeholder="placeholder" dataLayout="n"/>-->

                      <!--<hr>-->
                      <!--<InputText hasToKeyboard value="hutext1" title="hutext1" placeholder="placeholder" dataLayout="hutext1"/>-->
                      <!--<InputText hasToKeyboard value="hutext2" title="hutext2" placeholder="placeholder" dataLayout="hutext2"/>-->
                      <!--<InputText hasToKeyboard value="hunum1" title="hunum1" placeholder="placeholder" dataLayout="hunum1"/>-->
                      <!--<hr>-->
                      <!--<InputText hasToKeyboard value="normal" title="normal" placeholder="placeholder" dataLayout="normal"/>-->
                      <!--<InputText hasToKeyboard value="numeric" title="numeric" placeholder="placeholder" dataLayout="numeric"/>-->
                      <!--<InputText value="nincs keyb." title="numeric" placeholder="Nincs keyboard itt" dataLayout="numeric"/>-->


                    </div>
                    <div class="col-sm-8 scrollHeightEnable600x fContent pt-15-i pb-15-i pl-15-i pr-15-i">


                      <div class="hiddenSzb">
                        <input type="text" name="del">
                        <input type="text" id="id" name="id" class="form-control id" value="">
                        <input type="text" id="id_buyer" v-model="data.id_buyer" class="form-control id_buyer" value="">
                        <input type="text" id="businesspartner" v-model="data.businesspartner" class="form-control businesspartner" value="">
                      </div>

                      <div class="row pl-15-i-sm pr-15-i-sm">
                        <div class="col col-12 ">
                          <ProductChooser>data.selltype</ProductChooser>
                        </div>
                      </div>

                      <hr>


                      <div class="row form-group" v-if="hasselltext">
                        <div class="col col-md-4 extensionLine"><label for="selltext" class=" form-control-label">{{$t('sellinone.selltext')}}</label>
                        </div>
                        <div class="col-12 col-md-8">
                          <InputText hasToKeyboard="auto" id="selltext" v-model="data.selltext" title="Megjegyzés" placeholder="" dataLayout="t" className="form-control"/>
                        </div>
                      </div>
                      <!--
                      <div class="col-4 scrollHeightEnable600x receiptDisplayContainer fContent pt-15 pb-15">
                      </div>
                      <div class="fFix">
                      </div>
                      -->


                    </div>


                  </div>

                  <div class="row fFix">
                    <div class="col-sm-4 scrollHeightEnable600x receiptDisplayContainer fContent pt-15 pb-15"></div>
                    <div class="col-sm-8 scrollHeightEnable600x fContent pt-15-i pb-15-i pl-15-i pr-15-i">

                      <div class="row form-group">
                        <div class="col col-4">
                          <div class="">
                            <div class="radio">
                              <label for="radio1" class="btn form-check-label form-control border-sel"
                                     :class="(Number(data.selltype)===1)?' btn-success ':' btn-outline-secondary '">
                                <template v-if="Number(data.selltype)===1">
                                  <i class="fa fa-dot-circle-o fontsizebigger"></i>
                                </template>
                                <template v-if="Number(data.selltype)===2">
                                  <i class="fa fa-circle-o fontsizebigger"></i>
                                </template>
                                <template v-if="Number(data.selltype)===3">
                                  <i class="fa fa-circle-o fontsizebigger"></i>
                                </template>
                                <input type="radio" id="radio1" value="1" v-model="data.selltype" checked class="invisible form-check-input" style="height: 0px;"> {{$t('sellinone.selltype1')}}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col col-4">
                          <div class="">
                            <div class="radio">
                              <label for="radio2" class="btn form-check-label form-control border-sel"
                                     :class="(Number(data.selltype)===2)?' btn-success ':' btn-outline-secondary '">
                                <template v-if="Number(data.selltype)===1">
                                  <i class="fa fa-circle-o fontsizebigger"></i>
                                </template>
                                <template v-if="Number(data.selltype)===2">
                                  <i class="fa fa-dot-circle-o fontsizebigger"></i>
                                </template>
                                <template v-if="Number(data.selltype)===3">
                                  <i class="fa fa-circle-o fontsizebigger"></i>
                                </template>
                                <input type="radio" id="radio2" value="2" v-model="data.selltype" class="invisible form-check-input" style="height: 0px;"> {{$t('sellinone.selltype2')}}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col col-4">
                          <div class="">
                            <div class="radio">
                              <label for="radio3" class="btn form-check-label form-control border-sel"
                                     :class="(Number(data.selltype)===3)?' btn-success ':' btn-outline-secondary '">
                                <template v-if="Number(data.selltype)===1">
                                  <i class="fa fa-circle-o fontsizebigger"></i>
                                </template>
                                <template v-if="Number(data.selltype)===2">
                                  <i class="fa fa-circle-o fontsizebigger"></i>
                                </template>
                                <template v-if="Number(data.selltype)===3">
                                  <i class="fa fa-dot-circle-o fontsizebigger"></i>
                                </template>
                                <input type="radio" id="radio3" value="3" v-model="data.selltype" class="invisible form-check-input" style="height: 0px;"> {{$t('sellinone.selltype3')}}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>


              </div>

              <div class="fFix card-footer text-center">
                <button v-on:click="goNext()" type="button" class="btn btn-success btn-lg btn-save">
                  <!--<i class="fa fa-dot-circle-o"></i> -->
                  {{$t('sellinone.goNext')}}
                  <i class="fa fa-angle-double-right"></i>

                  <!--&gt;>-->
                </button>
              </div>


            </div>


          </form>


        </div><!-- .animated -->
        <div class="h40p"></div>
      </div><!-- .content -->


    </div>

    <!-- Right Panel -->
  </div>

</template>

<script>

  // @ is an alias to /src
  import SellHeader from '@/components/SellHeader.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import InputText from '@/components/InputText.vue';
  import LinkToTemplate from "../components/LinkToTemplate";
  import BarcodeGenerator from '@/components/BarcodeGenerator.vue';
  import JsBarcode from 'jsbarcode';
  //    import Sync from '@/components/Sync.vue';
  import BuyerSearcher from "../components/BuyerSearcher";
  import ProductSearcher from "../components/ProductSearcherMass";
  import BasketDisplayer from "../components/BasketDisplayer";
  import ProductTabs from "../components/ProductTabs";
  import ProductChooser from "../components/ProductChooser";
  //    import SyncHandler from '@/sync/syncHandler';
  //    const machineId = require('node-machine-id').machineId;
  //    const machineIdSync = require('node-machine-id').machineIdSync;
  //    const {ipcRenderer} = require('electron');

  //    const sqlite3 = require('sqlite3').verbose();

  export default {
    name: 'Sellinone',
    data() {
      return {
        prefix: "",
        suffix: "",
        purcaseItems: [],
        purcaseItemsExtend: [],
        cachedElements: [],
        data: {
          "id": "",
          "selltext": "",
          "selltype": "1",
          "parent_id": 0,
        },
        dataBase: {
          "id": "",
          "selltext": "",
          "selltype": "1",
          "parent_id": 0,
        },
        discount: 0,
        discount_price: 0,
        discount_percentage: 0,
        sum: 0,
        buyer: {},
        businesspartner: {},
        discountchooses: [],
        choosedDiscount: null,
        hasselltext: false,
        AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          delay: 5000,
        },
      };
    },
    props: {
      id: String,
    },
    watch: {
      discount: function (newData, oldData) {
        const modul = this;
        modul.makeBasketCalculation();
      },
      purcaseItems: function (newData, oldData) {
        const modul = this;
        const purcaseItemsExtend = [];
        Array.prototype.forEach.call(newData, function (e) {
          const eCopied = Object.assign({}, e);
//          purcaseItemsExtend.push(Object.assign(eCopied, modul.getElementByIdSync(e.itemKey)));
          purcaseItemsExtend.push(Object.assign(eCopied, modul.getElementFromCachedElementsById(e.itemKey)));
        });
        this.purcaseItemsExtend = purcaseItemsExtend;
        modul.makeBasketCalculation();
      },
      buyer: function (newData, oldData) {
        const modul = this;
        modul.makeBasketCalculation();
      },
      businesspartner: function (newData, oldData) {
        const modul = this;
        modul.makeBasketCalculation();
      },
      "choosedDiscount": function (newData, oldData) {
        const modul = this;
        modul.makeBasketCalculation();
      },
    },
    mounted() {
      // window.db.boolDump=true;
      const modul = this;
      console.log(this.$route.name + " mounded");
      modul.roles = [2, 3, 4, 5, 6, 7, 8, 9, 10];

      const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
      if (!Helper.checkRoles(modul.roles, role)) {
        modul.$router.push({name: "login"})
      }
      modul.prefix = Helper.getMoneyDefaultDisplayPrefix();
      modul.suffix = Helper.getMoneyDefaultDisplaySuffix();
      // Bárkód termék
      modul.$eventBus.$on('globalReadElement', modul.globalReadElementEventHandler);
      modul.$eventBus.$on('globalReadElementSid', modul.globalReadElementEventHandlerSid);
      // Felületen beütött termék
      modul.$eventBus.$on('globalAddPurcaseElement', this.globalAddPurcaseElementEventHandler);
      modul.$eventBus.$on('globalReset', modul.globalResetHandler);
      // Buyer
      modul.$eventBus.$on('globalReadBusinessPartnerSid', modul.globalReadBusinessPartnerSidEventHandler);
      modul.$eventBus.$on('globalSetBuyer', modul.globalSetBuyerEventHandler);
      modul.$eventBus.$on('globalSetBusinessPartner', modul.globalSetBusinessPartner);
      modul.$eventBus.$on('globalAddCachedElements', modul.globalAddCachedElements);

// TODO --- na ez tök máshogy kell / lesz
      if (modul.$route.params.data) {

        modul.data = modul.$route.params.data;
        modul.data.id = modul.$route.params.data.id;
        modul.data.selltext = modul.$route.params.data.selltext;
        modul.data.selltype = modul.$route.params.data.selltype;
        modul.choosedDiscount = modul.$route.params.choosedDiscount;
        modul.discount = (modul.$route.params.data.discount_type) ? Number(modul.$route.params.data.discount_type) : 0;
        modul.data.discount_type = (modul.$route.params.data.discount_type) ? Number(modul.$route.params.data.discount_type) : 0;

        modul.purcaseItems = modul.$route.params.purcaseItems;
        modul.cachedElements = modul.$route.params.cachedElements;

        // handle buyer
        const id_buyer = modul.$route.params.data.id_buyer;
        if (id_buyer) {
          modul.getBuyerById(function (err, res) {
            if (!err) {
              if (res && res.id) { //  res[0] &&
                modul.buyer = res;
                modul.$eventBus.$emit('globalSetBuyerSid', res.sid);
              }
            }
          }, id_buyer)
        }
        // handle businesspartner
        const id_businesspartner = modul.$route.params.data.id_businesspartner;
        if (id_businesspartner) {
          modul.getBusinessPartnerById(function (err, res) {
            if (!err) {
              if (res && res.id) { // res[0] &&
                modul.businesspartner = res;
                modul.$eventBus.$emit('globalSetBusinessPartner', res);
              }
            }
          }, id_businesspartner)
        }

//                console.log("sellinone init as id: " + modul.$route.params.sellId);
//                // TODO ide kell enek a lekérések, amik beolvassák az eladást!!
//                modul.getSell(function (err, res) {
//                    if (res && res[0] && res[0].id) {
//                        // set sell data
//                        modul.data.id = res[0].id;
//                        modul.data.selltext = res[0].selltext;
//                        modul.data.selltype = res[0].selltype;
//                        modul.discount = Number(res[0].discount_type);
//                        modul.data.discount_type = Number(res[0].discount_type);
//                        // handle sell_element
//                        modul.getSellElementsBySellid(function (err, res) {
//                            if (res) {
//                                let purcaseItems = [];
//                                res.forEach(function (e) {
//                                    if (Number(e.type) === 1) {
//                                        purcaseItems.push({itemKey: Number(e.id_element), itemValue: Number(e.price)}); // countnum vagy price
//                                    } else if (Number(e.type) === 2) {
//                                        purcaseItems.push({itemKey: Number(e.id_element), itemValue: Number(e.countnum)}); // countnum vagy price
//                                    } else if (Number(e.type) === 3) {
//                                        purcaseItems.push({itemKey: Number(e.id_element), itemValue: Number(e.countnum)}); // countnum vagy price
//                                    }
//                                });
//                                modul.purcaseItems = purcaseItems;
//                            }
//                        }, modul.$route.params.sellId)
//
//                        // handle buyer
//                        const id_buyer = res[0].id_buyer;
//                        if (id_buyer) {
//                            modul.getBuyerById(function (err, res) {
//                                if (!err) {
//                                    if (res && res[0] && res[0].id) {
//                                        modul.buyer = res[0];
//                                        modul.$eventBus.$emit('globalReadBuyerSid', res[0].sid);
//
////                                        if (res[0].discount) {
////                                            modul.discount = res[0].discount;
////                                        } else {
////                                            modul.discount = 0;
////                                        }
//                                    }
//                                }
//                            }, id_buyer)
//                        }
//                    }
//                }, modul.$route.params.sellId)
//                alert("Jajj, meg kell oldani!")


      } else {
        console.log("sellinone init as EMPTY");
        modul.emptyForNew();
      }
//            modul.getElementCategories();
      modul.getDiscountChooses(function (err, res) {
        if (err) {
          return;
        }
        modul.discountchooses = res;
      });
//            modul.initGlobalListener();
//            modul.doGlobalListener();
      if (localStorage.getItem("hasselltext")) {
        modul.hasselltext = ("true" === localStorage.getItem("hasselltext"));
      } else {
        modul.hasselltext = false; // for modify the default value use the settings screen too
      }

    },
    beforeDestroy() {
      const modul = this;
      modul.$eventBus.$off('globalReadElement');
      modul.$eventBus.$off('globalAddPurcaseElement');
      modul.$eventBus.$off('globalReadBusinessPartnerSid');
      modul.$eventBus.$off('globalSetBuyer');
      modul.$eventBus.$off('globalSetBusinessPartner');
      modul.$eventBus.$off('globalReset');
      modul.$eventBus.$off('globalAddCachedElements');
//            ipcRenderer.send('datasend', {emit: true, type: "globalPurcaseItemsExtendMoify", data: {purcaseItemsExtend: []}});
//            ipcRenderer.send('datasend', {emit: true, type: "globalBasketDataSend", data: {basketData: {discount: "", sum: "", discount_price: "",}}});
//            modul.offGlobalListener();
    },
    methods: {
      getElementFromCachedElementsById: function (itemKey) {
        const modul = this;
        const element = Helper.getObjectByIdFromObjectArray(modul.cachedElements, itemKey);
        return element;
      },

      clickToClearBusinessPartner(){
        const modul = this;
        modul.$eventBus.$emit('globalSetBusinessPartner', {});
      },

//            doGlobalListener: function (e) {
//                const modul = this;
//                ipcRenderer.send('datasend', e);
//            },
//            initGlobalListener: function () {
//                const modul = this;
////                ipcRenderer.removeAllListeners('updatemarker-reply');
//                ipcRenderer.on('datasend-reply', (event, arg) => {
//                    if (arg.type === "update-available") {
//                        window.hasUpdate = true;
//                    }
//                });
//            },
//            offGlobalListener: function () {
//                ipcRenderer.removeAllListeners('datasend-reply');
//            },

      doSell(){
//                SyncHandler.handle({job: 'doSell'});
      },
      globalSetBuyerEventHandler(buyer){
        const modul = this;
        modul.buyer = Object.assign({}, buyer);
        console.log(buyer)
        if (buyer.discount) {
//                    modul.discount = Number(buyer.discount);
          modul.discount = modul.calculateDiscount();
        } else {
          modul.discount = 0;
          modul.choosedDiscount = 0;
        }
        modul.makeBasketCalculation();
      },
      globalSetBusinessPartner(businesspartner){
        const modul = this;
        modul.businesspartner = Object.assign({}, businesspartner);
        console.log(businesspartner)
        if (businesspartner.discount) {
//                    modul.discount = Number(buyer.discount);
          modul.discount = modul.calculateDiscount();
        } else {
          modul.discount = 0;
          modul.choosedDiscount = 0;
        }
        modul.makeBasketCalculation();
      },
      globalReadBusinessPartnerSidEventHandler(businesspartner){
        const modul = this;
        console.log("sellinode - globalSetBusinessPartner")
        modul.$eventBus.$emit('globalSetBusinessPartner', businesspartner);
      },
      globalAddCachedElements(cachedElements){
        if (Array.isArray(cachedElements)) {
          const modul = this;
          const mergedCachedElements = modul.cachedElements.concat(cachedElements);
          const arrKeys = [];
          const newCachedElements = [];
          Array.prototype.forEach.call(mergedCachedElements, function (e) {
            if (arrKeys.indexOf(e.id) === -1) { // item not found
              newCachedElements.push(e)
              arrKeys.push(e.id)
            }
          })
          modul.cachedElements = newCachedElements;
        }
      },
      globalReadBuyerSidEventHandler(sid){
        const modul = this;
        console.log("setsid")
        modul.sid = sid;
      },
      calculateDiscount: function () {
        const modul = this;
        let actualDiscount = 0; //modul.discount; // modul.data.discount_type
        if (modul.choosedDiscount !== null) { // &&Number(modul.choosedDiscount>actualDiscount)
          actualDiscount = Number(modul.choosedDiscount);
        }
        let buyerDiscount = 0;
        if (typeof modul.buyer.discount !== "undefined") {
          buyerDiscount = Number(modul.buyer.discount);
        }
        if (Number(buyerDiscount) >= Number(actualDiscount)) {
          actualDiscount = buyerDiscount;
        }
        let businesspartnerDiscount = 0;
        if (typeof modul.businesspartner.discount !== "undefined") {
          businesspartnerDiscount = Number(modul.businesspartner.discount);
        }
        if (Number(businesspartnerDiscount) >= Number(actualDiscount)) {
          actualDiscount = businesspartnerDiscount;
        }
        return actualDiscount;
      },
//                let actualDiscount = modul.data.discount_type; // modul.data.discount_type
//                if (modul.choosedDiscount!==null) {
//                    actualDiscount = modul.choosedDiscount;
//                }
//                let buyerDiscount = 0;
//                if (typeof modul.buyer.discount !== "undefined") {
//                    buyerDiscount = Number(modul.buyer.discount);
//                }
//                if (Number(buyerDiscount)> Number(actualDiscount)) {
//                    actualDiscount = buyerDiscount;
//                }
      goNext: function () {
        console.log('goNext!!!!!!!!!!!!!!!!');
        const modul = this;
        console.log(modul.data);
        console.log(modul.buyer);
        console.log(modul.purcaseItems);

        let data = {};
        data.id = null;
        if (modul.data.id) {
          data.id = modul.data.id;
        }
        if (window && window.user && window.user.id) {
          data.id_adminuser = window.user.id;
        }
        if (window && window.user && window.user.sync_pk) {
          data.sync_pk_adminuser = window.user.sync_pk;
        }
        data.id_buyer = null;
        data.id_businesspartner = null;
        if (modul.buyer.id) {
          data.id_buyer = modul.buyer.id;
        }
        if (modul.businesspartner.id) {
          data.id_businesspartner = modul.businesspartner.id;
        }
//                data.discount_type = null;
//                if (typeof modul.buyer.discount !== "undefined") {
//                    data.discount_type = modul.buyer.discount;
//                } else if (modul.calculateDiscount(modul.sum)) {
        data.discount_type = modul.calculateDiscount(modul.sum);
//                }
        data.sum = modul.sum;
        data.selltext = modul.data.selltext;
        data.selltype = modul.data.selltype;
//                data.wsid = machineIdSync();
        data['datetime'] = Helper.getNewUTCDateTime(); //new Date();
        data['sync_mdt'] = Helper.getNewUTCDateTime(); // Helper.createDateAsUTC(new Date());
        data = Helper.filterObjectByKeys(data, ["id", "id_buyer", "id_businesspartner", "datetime", "discount_type", "sum", "selltext", "selltype", "sync_pk_adminuser", "id_adminuser", "wsid"]);
        let sellId = data.id;
        if (Number(data.sum) === 0) {
          return;
        }

        const cb = function (err, res) {
//                    console.log("brékpoint")
//                    if (!sellId && window.db.lastInsertId("sell")) {
//                        modul.data.id = window.db.lastInsertId("sell");
//                        sellId = modul.data.id;
//                    }
//                    window.db.delete(
//                        function (err, res) {
//                            modul.saveCbDel(err, window.db.convertResToArray(err, res), {sellId: sellId, purcaseItems: modul.purcaseItems})
//                        }, "sell_element", "id_sell=" + sellId);
        };
        /*
         data['sync_mdt'] = Helper.getNewUTCDateTime(); //Helper.getNewUTCDateTime();
         if (data.id && !isNaN(Number(data.id))) {
         console.log("update --- IDE KELL RAKD A BRÉKPOINTOT!")
         window.db.update(
         function (err, res) {
         cb(err, window.db.convertResToArray(err, res))
         }
         , "sell", data, "id=" + sellId);
         } else {
         console.log(" pinsert --- IDE KELL RAKD A BRÉKPOINTOT!")
         data['create_dt'] = Helper.getNewUTCDateTime();
         window.db.pinsert(
         function (err, res) {
         cb(err, window.db.convertResToArray(err, res))
         }
         , "sell", data);
         }
         */
        modul.$router.push({
          name: "sell2", params: {data: data, purcaseItems: modul.purcaseItems, choosedDiscount: modul.choosedDiscount, cachedElements: modul.cachedElements}
        });


      },
      /*
       saveCbDel: function (err, res, data) {
       const modul = this;
       const purcaseItems = data.purcaseItems;
       const sellId = data.sellId;
       let count = purcaseItems.length;
       let actCount = 0;
       const cbInsert = function (err, res) {
       actCount++;
       if (count === actCount) {
       modul.$router.push({
       name: "sell2", params: {
       sellId: modul.data.id,
       }
       });
       }
       };
       Array.prototype.forEach.call(purcaseItems, function (purcaseItem) {
       let elementDb = {}; //Object.assign({}, purcaseItem);
       elementDb.id_sell = sellId;
       elementDb.id_element = purcaseItem.itemKey;

       modul.getElementById(function (err, res) {
       if (res && res[0]) {


       const item = res[0]; //modul.getItemById(purcaseItem.id);
       // console.log("item");
       // console.log(item);
       if (Number(item.type) === 1) {
       elementDb.countnum = null;
       elementDb.price = Number(purcaseItem.itemValue);
       } else if (Number(item.type) === 2) {
       elementDb.countnum = Number(purcaseItem.itemValue);
       elementDb.price = Number(item.default_price) * Number(purcaseItem.itemValue);
       // purcaseItem.countnum = item.countnum;
       // (Number(item.default_price) * purcaseItem.countnum)
       } else if (Number(item.type) === 3) {
       elementDb.countnum = Number(purcaseItem.itemValue);
       elementDb.price = Number(item.default_price) * Number(purcaseItem.itemValue);
       // purcaseItem.countnum = item.countnum;
       // (Number(item.default_price) * purcaseItem.countnum)
       }

       elementDb.id_sell = Number(elementDb.id_sell);
       elementDb.id_element = Number(elementDb.id_element);
       elementDb = window.db.filterObjectByKeys(elementDb, ["id_sell", "id_element", "price", "countnum"]);
       if (!elementDb.id_element) {
       //                                alert("alertéááááááááááááááááááá");
       //                                confirm("confirméááááááááááááááááááá");
       //                                console.log("éááááááááááááááááááá:");
       //                                console.log("elementDb:");
       //                                console.log(elementDb);
       //                                console.log("purcaseItem:");
       //                                console.log(purcaseItem);

       }
       elementDb['sync_mdt'] = Helper.getNewUTCDateTime(); //Helper.createDateAsUTC(new Date());

       console.log("pinsert -- sellelement --- IDE KELL RAKD A BRÉKPOINTOT!")
       elementDb['create_dt'] = Helper.getNewUTCDateTime();
       window.db.pinsert(
       function (err, res) {
       cbInsert(err, window.db.convertResToArray(err, res))
       }
       , "sell_element", elementDb);

       }
       }, Number(purcaseItem.itemKey))


       })
       },
       */

      reprint: function () {
        const modul = this;
        modul.getLastSellId(function (err, res) {
          if (res && res[0] && res[0].id) {
            const sellprintId = res[0].id;
            // TODO  -- NEED PRINT FOR HERE!!
            modul.$router.push({
              name: "sellprint", params: {
                sellId: sellprintId,
              }
            });

          }
        });
      },


      globalResetHandler(obj){
        const modul = this;
        if (obj.name === "sellinone") {
          modul.emptyForNew()
        }
      },
      emptyForNew(){
        const modul = this;
        modul.data = Object.assign({}, modul.dataBase);
        modul.stock = {};
        modul.buyer = {};
        modul.businesspartner = {};
        modul.discount = 0;
        modul.discount_price = 0;
        modul.discount_percentage = 0;
        modul.sum = 0;
        modul.purcaseItems = [];
        modul.purcaseItemsExtend = [];
        modul.choosedDiscount = null;
        modul.$eventBus.$emit('globalSetBuyerSid', "");
        modul.$eventBus.$emit('globalResetCategoriesChooser', "");
        modul.$eventBus.$emit('globalChooseProductSearcher', {type: 'ProductSearcherMass'})
//                this.$router.push({name: "selproduct"})
      },

      globalReadElementEventHandlerSid(barcode){
          console.log("globalReadElementEventHandler")
        const modul = this;
        modul.getElementByBarcode(function (err, res) {
          if (res && res[0] && res[0].id) {
            const item = {itemKey: res[0].id, itemValue: "1"};
            const dbElement = res[0];
            item.itemPrice = Number(dbElement.default_price);
            item.itemSumPrice = Number(dbElement.default_price);
            item.itemCountnum = 1;
            let purcaseItems = [];
            modul.purcaseItems.forEach(function (e) {
              purcaseItems.push(e);
            });
            purcaseItems.push(item);
            modul.purcaseItems = purcaseItems;
            modul.$eventBus.$emit('globalSetPurcaseItems', modul.purcaseItems);

          }
        }, barcode);
      },
      globalReadElementEventHandler(element){
          console.log("globalReadElementEventHandler")
        const modul = this;
          // TODO itt ezt hozzá kell adni a cached elementekhez
        modul.cachedElements = modul.cachedElements.concat(element);
//        modul.getElementByBarcode(function (err, res) {
//          if (res && res[0] && res[0].id) {
            const item = {itemKey: Helper.Number(element.id), itemValue: 1};
            const dbElement = element;
            item.itemPrice = Number(dbElement.default_price);
            item.itemSumPrice = Number(dbElement.default_price);
            item.itemCountnum = 1;
            let purcaseItems = [];
            modul.purcaseItems.forEach(function (e) {
              purcaseItems.push(e);
            });
            purcaseItems.push(item);
            modul.purcaseItems = purcaseItems;
            modul.$eventBus.$emit('globalSetPurcaseItems', modul.purcaseItems);

//          }
//        }, barcode);
      },


      globalAddPurcaseElementEventHandler(element){
        const modul = this;
        console.log("globalAddPurcaseElement - sellinone")
        if (element.hasOwnProperty("itemKey") && element.hasOwnProperty("itemValue")) {
          let purcaseItems = [];
          modul.purcaseItems.forEach(function (e) {
            purcaseItems.push(e);
          });
          purcaseItems.push({itemKey: element.itemKey, itemValue: element.itemValue, itemPrice: element.itemPrice, itemCountnum: element.itemCountnum, itemSumPrice: element.itemSumPrice});
          modul.purcaseItems = purcaseItems;
        }
      },
      discountChooserElementClickHandler(choosedDiscount){
        const modul = this;
        console.log("discountChooserElementClickHandler");
        modul.choosedDiscount = choosedDiscount;
        modul.makeBasketCalculation();
      },

      makeBasketCalculation(){
        const modul = this;
        console.log("makeBasketCalculation");
        let sum = 0;
        modul.purcaseItemsExtend.forEach(function (item) {
          sum += Number(item.itemSumPrice);

//                    let val = item.itemValue;
////                    let item = modul.getItemById(e.itemKey);
//                    if (Number(item.pack) === 1) {
//                        if (val && Number(val).toString() === val.toString()) {
//                            sum += Number(val);
//                        }
//                    } else if (Number(item.pack) >= 2 && Number(item.pack) <= 7) {
//                        if (val && Number(val).toString() === val.toString()) {
//                            sum += Number(item.default_price) * item.itemValue;
//                        }
//                    }
        });

        let sumDiscont = 0;
        let discount = 0;

//                if (typeof modul.buyer.discount !== "undefined") {
//                    discount = Number(modul.buyer.discount);
//                } else if (modul.calculateDiscount(modul.sum)) {
        discount = modul.calculateDiscount(sum);
//                }
        modul.discount = discount;

        sumDiscont = parseFloat(100 - Number(discount)) * parseFloat(0.01) * sum;
        sumDiscont = Helper.roundToProjectDecimal(sumDiscont);
        modul.sum = Helper.getFormattedPrice(sumDiscont);
        let discount_price = 0;
        if (discount && Number(discount).toString() === discount.toString() && discount !== 0) {
          discount_price = Helper.roundToProjectDecimal(( Number(discount)) * parseFloat(0.01) * sum);
        }
        modul.discount_price = Helper.getFormattedPrice(discount_price);

        const basketData = {
          discount: modul.discount,
          sum: modul.sum,
          discount_price: modul.discount_price,
        };
//                ipcRenderer.send('datasend', {emit: true, type: "globalPurcaseItemsExtendMoify", data: {purcaseItemsExtend: modul.purcaseItemsExtend}});
//                ipcRenderer.send('datasend', {emit: true, type: "globalBasketDataSend", data: {basketData: basketData}});

      },
      delrow: function (id) {
        const modul = this;
        Array.prototype.forEach.call(modul.purcaseItems, function (e, i) {
          if (Number(i) === Number(id)) {
            delete(modul.purcaseItems[i]);
          }
        });
        const purcaseItems = [];
        modul.purcaseItems.forEach(function (e) {
          purcaseItems.push(e);
        });
        modul.purcaseItems = purcaseItems;
      },

      // -------------------------------------------------


//            getElementCategories: function (cb, id) {
//                const model = this;
//                window.db.select(
//                    function (err, res) {
//                        let arrRes = window.db.convertResToArray(err, res);
//                        cb(err, arrRes)
//                    }
//                    , "element_category", "*", "deleted = 0 and parent_id=" + id, " name asc");
//            },
//            getElementByCategoryId: function (cb, id, type = null) {
//                const model = this;
//                let stringType = "";
//                if (type !== null) {
//                    stringType = " and type = " + Number(type) + " ";
//                }
//                window.db.select(
//                    function (err, res) {
//                        let arrRes = window.db.convertResToArray(err, res);
//                        cb(err, arrRes)
//                    }
//                    , "element left join stock on stock.id_element=element.id", "element.*, stock.count count", "deleted = 0 and parent_id=" + id + stringType, " name asc");
//            },
      /**
       * Ha vissza-val jövünk szerkesztésre
       * @param cb
       * @param id_sell
       */
//            getSellElementsBySellid: function (cb, id_sell) {
//                console.log("getSellElementsBySellid");
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "sell_element left join element on element.id = sell_element.id_element", "*", "id_sell=" + id_sell); // left join element on element.id = sell_element.id_element  -- , element.id id
//            },
      getElementById: function (cb, id) {
        const modul = this;
        Api.getElementById(id).then(function (e) {
          if (e && e.result === true) {
            console.log(e)
            modul.cachedElements = modul.cachedElements.concat(e.data);
            cb(null, e.data);
          }
        }, function (err) {
          console.log(err)
          cb(err, null);
        });

//        window.db.select(
//          function (err, res) {
//            let arrRes = window.db.convertResToArray(err, res);
//            cb(err, arrRes)
//          }
//          , "element", "*", "id=" + Number(id) + " AND (`deleted` = 0 OR `deleted` = '0')"); //  AND type = 2
////                    , "element", "*", "id=" + Number(id) + " OR id=" + window.db.quote(id) + " AND (`deleted` = 0 OR `deleted` = '0')"); //  AND type = 2

      },
//      getElementByIdSync: function (id) {
//        const modul = this;
//        const cb = function () {
//        };
//        Api.getElementById(id).then(function (e) {
//          if (e && e.result === true) {
//            console.log(e)
//            modul.cachedElements = modul.cachedElements.concat(e.data);
//            cb(null, e.data);
//          }
//        }, function (err) {
//          console.log(err)
//          cb(err, null);
//        });
//
////        const elements = window.db.select(
////          function (err, res) {
////          }
////          , "element", "*", "id=" + Number(id) + " AND (`deleted` = 0 OR `deleted` = '0') "); // AND (`type` = 2 OR `type` = '2')
////        let element = {};
////        if (elements && elements[0] && elements[0].id) {
////          element = elements[0];
////        }
////        return element;
//      },
      getBuyerById: function (cb, id) {
        Api.getBuyer({id: id}).then(function (e) {
          if (e && e.result === true) {
            console.log(e)
            cb(null, e.data);
          }
        }, function (err) {
          console.log(err)
          cb(err, null);
        });

//        window.db.select(
//          function (err, res) {
//            cb(err, window.db.convertResToArray(err, res))
//          }
//          , "buyer", "*", "(id=" + id + " OR id=" + Number(id) + ") AND (`deleted` = 0 OR `deleted` = '0')");
      },
      getBusinessPartnerById: function (cb, id) {
        Api.getBusinessPartner({id: id}).then(function (e) {
          if (e && e.result === true) {
            console.log(e)
            cb(null, e.data);
          }
        }, function (err) {
          console.log(err)
          cb(err, null);
        });
//        window.db.select(
//          function (err, res) {
//            cb(err, window.db.convertResToArray(err, res))
//          }
//          , "businesspartner", "*", "(id=" + id + " OR id=" + Number(id) + ") AND (`deleted` = 0 OR `deleted` = '0')");
      },
      getElementByBarcode: function (cb, barcode) {
        const modul = this;

        Api.getElementByBarcode(id).then(function (e) {
          if (e && e.result === true) {
            console.log(e)
            cb(null, e.data);
          }
        }, function (err) {
          console.log(err)
          cb(err, null);
        });


//        window.db.select(
//          function (err, res) {
//            let arrRes = window.db.convertResToArray(err, res);
//            cb(err, arrRes)
//          }
//          , "element", "*", "barcode=" + window.db.quote(barcode) + " AND (`deleted` = 0 OR `deleted` = '0')"); // AND (`type` = 2 OR `type` = '2')
      },


//            getSell: function (cb, id) {
//                console.log("getSell");
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "sell left join buyer on buyer.id = sell.id_buyer", "*, concat(pre_name, ' ',first_name, ' ',last_name) buyertext, sell.id id", "sell.id=" + id);
//            },
      getDiscountChooses: function (cb) {
        console.log("getDiscountChooses");
        Api.getDiscountChooses({}).then(function (e) {
          if (e && e.result === true) {
            console.log(e)
            cb(null, e.data);
          }
        });
//        window.db.select(
//          function (err, res) {
//            cb(err, window.db.convertResToArray(err, res))
//          }
//          , "discount_choose", "*", "(`deleted` = 0 OR `deleted` = '0') AND (`active` = 1 OR `active` = '1')");
      },
      getLastSellId: function (cb, id) {
        console.log("getLastSellId");
        window.db.select(
          function (err, res) {
            cb(err, window.db.convertResToArray(err, res))
          }
          , "sell ", "id", "1", "id desc", "1");
      },
//            getElementTypes: function (cb) {
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    // TODO left join for stock
//                    , "element ", "type", "(`deleted` = 0 OR `deleted` = '0') group by type");
//            },


    },
    components: {
      LinkToTemplate,
      InputText,
      SellHeader,
      AlertInPage,
      BarcodeGenerator,
      BuyerSearcher,
      ProductSearcher,
      ProductTabs,
      ProductChooser,
      BasketDisplayer
    },
  };
</script>


<style scoped>
  .fontsizebigger {
    font-size: 17px;
  }
</style>
<style>

  .sellinone .searchResultContainer {
    position: relative;
    top: 0;
    left: 0;
  }

  .sellinone .searchResult {
    position: relative;
    background-color: white;
    width: 100%;
    z-index: 5;
    left: 0;
    top: 0;
    margin-bottom: 15px;
  }

  .sellinone .scrollHeightEnable600 {
    overflow: auto;
    max-height: 600px;
  }

  /*.sellinone .discount_type {*/
  /*width: 16px;*/
  /*}*/

  .sellinone span.sum {
    color: red;
    font-size: 2rem;
  }

  .sellinone label.sum {
    color: red;
    font-size: 1.4rem;
  }

  .sellinone .customPaddingTop {
    padding-top: 1px;
  }

  .sellinone .sell .discount_type_container {
    /*font-size: 1rem;*/
    padding: 0.1rem .55rem;
    color: blue;
  }

  .sellinone .sell .sid2_keyboard {
    width: 1px;
    max-width: 1px;
    border-width: 0;
  }

  .sellinone .dataTables_filter {
    display: none;
  }

  .sellinone .sid.is-invalid {
    background-color: #f1b0b7;
  }

  /* ------------- */
  .sellinone .elementContainer {
    display: block;
    text-align: justify;
    margin: -3px -3px 3px -3px;
  }

  .receiptDisplayContainer .icons {
    width: 1%;
  }

  .discountChooser table {
    margin: 0 0 0 auto;
  }

  /*.sellinone .elementContainer:after {*/
  /*content: '';*/
  /*display: block;*/
  /*clear: both;*/
  /*}*/
  /*.sellinone .box{*/
  /*!*display:inline-block;*!*/
  /*!*display:grid;*!*/
  /*border:1px solid grey;*/
  /*float: left;*/
  /*text-align:center;*/
  /*}*/

  /*.sellinone .box:before {*/
  /*content: "";*/
  /*display: inline-block;*/
  /*vertical-align: middle;*/
  /*height: 0;*/
  /*}*/
  /*!*.box.box-50{*!*/
  /*!*width: 50px;*!*/
  /*!*height: 50px;*!*/
  /*!*}*!*/
  /*!*.box.box-100-50{*!*/
  /*!*width: 100px;*!*/
  /*!*height: 50px;*!*/
  /*!*}*!*/
  /*.sellinone .box.box-x{*/
  /*min-width: 100px;*/
  /*height: 3.3em;*/
  /*!*max-width: 135px;*!*/
  /*margin:3px;*/
  /*!*padding: 0 3px;*!*/
  /*overflow: hidden;*/
  /*border-radius: 4px;*/
  /*!*border-color: #888;*!*/
  /*border-top: 4px solid rgb(33, 37, 41);*/
  /*text-align: left;*/
  /*}*/
  /*.sellinone .btn-box{*/
  /*position: relative;*/
  /*top: 0;*/
  /*left: 0;*/
  /*cursor: pointer;*/
  /*}*/

  /*.sellinone .btn-box label{ display: block;*/
  /*!*width: 100%;*!*/
  /*!*height: 100%;*!*/
  /*margin: 0;*/
  /*!*padding: 0;*!*/
  /*!*position: absolute;*!*/
  /*!*top: 0;*!*/
  /*!*left: 0;*!*/
  /*cursor: pointer;*/
  /*}*/

  @page {
    margin-left: 25px;
    margin-right: 15px;
  }

  .categorybutton {
    display: inline-block;
    margin-right: 5px;
  }

  .sellinone .pt-05em-i {
    padding-top: 0.5em !important;
  }

  .pt-15-i {
    padding-top: 15px !important;
  }

  .pb-15-i {
    padding-bottom: 15px !important;
  }

  .pl-15-i {
    padding-left: 15px !important;
  }

  .pr-15-i {
    padding-right: 15px !important;
  }

  @media (max-width: 575.99px) {
    .pl-15-i-sm {
      padding-left: 15px !important;
    }

    .pr-15-i-sm {
      padding-right: 15px !important;
    }
  }


</style>
